<div class="flex flex-col h-full min-h-0 overflow-hidden box-border">
    <nav class="flex w-full flex-shrink-0 mt-4 mx-2 sm:mx-4">
        <ng-content select="[breadcrumbs]"></ng-content>
    </nav>

    <header class="flex justify-between items-center mt-2 mb-4 px-2 sm:px-4 flex-shrink-0">
        <ng-content select="[title]"></ng-content>
        <ng-content select="[actions]"></ng-content>
    </header>

    <div [class]="overflow() ? 'flex-1 overflow-auto' : 'flex-1 min-h-0 flex gap-4 relative px-2 sm:px-4'">
        <ng-content></ng-content>
    </div>
</div>
